import React from 'react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { FINAL_BODY, FINAL_HEADLINE, FINAL_KICKER, FINAL_QUOTE, MAIN_MOCKUP, MOCKUP_ALT, PRODUCT, finalMaybes } from '../data/poolContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-aqua/20 bg-black" aria-labelledby="final-title" data-id="element-120" data-mp="2nzfe4lzbfphf">
      <div className="mx-auto max-w-5xl px-5 pt-14 text-center sm:pt-20" data-id="element-121" data-mp="1qdi4zf6tswi5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-aqua" data-id="element-122" data-mp="1vagvzov70nc4">
          {FINAL_KICKER}
        </p>
        <h2 id="final-title" className="mx-auto mt-3 max-w-3xl font-display text-[2.3rem] font-bold uppercase leading-none text-frost-50 sm:text-[3.4rem]" data-id="element-123" data-mp="208s49v5uaps8">
          {FINAL_HEADLINE}
        </h2>

        <ul className="mx-auto mt-8 max-w-xl space-y-1.5" data-id="element-124" data-mp="17jl6iye7m481">
          {finalMaybes.map(m => <li key={m} className="text-[15px] leading-snug text-body sm:text-[16px]" data-id="element-125" data-mp="1cio09moqoo0p">
              {m}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-frost-100 sm:text-[16px]" data-id="element-126" data-mp="27ii67rm36ttc">
          {FINAL_BODY}
        </p>
        <p className="mt-2 font-display text-[2rem] font-bold uppercase text-pool-light sm:text-[2.4rem]" data-id="element-127" data-mp="22q8mwufh8s01">
          {FINAL_QUOTE}
        </p>
      </div>

      <div className="mx-auto grid max-w-5xl items-center gap-10 px-5 py-14 md:grid-cols-2 sm:py-16" data-id="element-128" data-mp="1trwow7ca6rxk">
        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm md:max-w-none" width={1199} height={1312} loading="lazy" data-id="element-129" data-mp="1os0sou9ts4sk" />

        <div className="text-center md:text-left" data-id="element-130" data-mp="1ev5vcepagafv">
          <p className="font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.4rem]" data-id="element-131" data-mp="1ewgws7v9h63t">
            {PRODUCT}
          </p>
          <p className="mt-2 text-[13px] font-medium uppercase tracking-[0.14em] text-body" data-id="element-132" data-mp="399f7utosc6s7">
            90-page practical guide + 4 bonus guides
          </p>

          <PriceBlock align="start" className="mt-6 border-t border-abyss-600 pt-6" data-id="element-133" data-mp="1c9empoknbknq" />

          <div className="mt-6 flex justify-center md:justify-start" data-id="element-134" data-mp="xks85p2uewxk">
            <CtaButton size="lg" data-id="element-135" data-mp="xmlhjc4ubv99" />
          </div>
          <TrustStrip variant="full" className="mt-4 md:justify-start" data-id="element-136" data-mp="12jbuhqlcmaqg" />
        </div>
      </div>
    </section>;
}